import request from '@/utils/request'

// 查询网点分类列表
export function listTenantCategory(query) {
  return request({
    url: '/upkeep/category/tenant/page',
    method: 'get',
    params: query,
  })
}

// 新增网点分类
export function batchAddTenantCategory(data) {
  return request({
    url: '/upkeep/category/tenant/add',
    method: 'post',
    data: data,
  })
}

// 修改网点分类
export function updateTenantCategory(data) {
  return request({
    url: '/system/tenantCategory',
    method: 'put',
    data: data,
  })
}

// 删除网点分类
export function delTenantCategory(data) {
  return request({
    url: 'upkeep/category/tenant/delete',
    method: 'post',
    data,
  })
}

// 批量删除网点分类
export function delTenantCategoryAll(ids) {
  return request({
    url: '/system/tenantCategory/' + ids.join(','),
    method: 'delete',
  })
}

export function getCategoryList(query) {
    return request({
        url: '/upkeep/category/page',
        method: 'get',
        params: query,
    })
}
